import React, { useEffect, useState } from "react";
import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import styles from "../../../../styles/pages/user/managerdashboard/manager-dashboard-messagedetails.module.scss";
import {
    Box,
    Button,
    Grid,
    List,
    ListItem,
    Paper,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import message_blog_image from "../../../../public/assets/images/messagedetails_inner.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import people from "../../../../public/assets/images/people.svg";
import UploadPin from "../../../../ui/Icons/UploadPin";
import DownArrowBlue from "../../../../ui/Icons/DownArrowBlue";
import { useRef } from "react";
import AddPlusIcon from "../../../../public/assets/icons/AddPlusIcon";
import TrashIcon from "../../../../public/assets/icons/TrashIcon";
import BtnCrossIcon from "../../../../public/assets/icons/BtnCrossIcon";
import BackArrow from "../../../../ui/Icons/BackArrow";
import UploadIcon from "../../../../ui/Icons/Upload";
import useFetch from "../../../../hooks/api/useFetch";
import ApiLoader from "../../../../components/Loaders/ApiLoader";
import {
    concatHostAndImagePath,
    getAbsoluteDownloadURI,
    getAbsoluteImageURI,
    getStyledDateTime,
} from "../../../../lib/functions/utils.lib";
import axiosInstance from "../../../../api/axiosInstance";
import assest from "../../../../json/assest";
import MessageTypeBox from "../../../../components/MessageTypeBox/MessageTypeBox";

export default function MessageDetails() {
    const { id } = useParams();
    const [message, setMessage] = useState(undefined);
    const [messageStatus, setMessageStatus] = useState({ name: "", class: "" });
    const [respondToInquiry, setRespondToInquiry] = useState(false);
    const handleRespondToInquiry = () => {
        setRespondToInquiry((prev) => !prev);
    };
    const handleDownload = (fileLink) => {
        window.open(getAbsoluteDownloadURI(fileLink), "_blank");
    };
    const {
        data: messageData,
        isError: messageDataisError,
        isLoading: messageDataisLoading,
        isSuccess: messageDataisSuccess,
        refetch: messageDatarefetch,
    } = useFetch("message-detail", `inquiry/${id}`);
    const updateInquiry = async (params) => {
        const { data } = await axiosInstance.post("update-inquery", {
            ...params,
            inquery_id: message?.id,
        });
        messageDatarefetch();
        return data;
    };
    const resolveInquiry = () => {
        updateInquiry({
            status: 1,
        });
    };
    const openInquiry = () => {
        updateInquiry({
            status: 0,
        });
    };
    const archiveInquiry = () => {
        updateInquiry({
            archive: 1,
        });
    };
    const router = useNavigate();
    const goBack = () => {
        router(
            message?.video
                ? "/manager-dashboard/messages"
                : "/manager-dashboard/support"
        );
    };
    const [sendButton, sendUpdateButton] = React.useState(false);

    const submitSendHandler = () => {
        sendUpdateButton(!sendButton);
    };

    const fileInput = useRef(null);

    const handleClick = () => {
        fileInput.current.children[0].children[0].click();
    };
    const getStatus = (inquiry) => {
        if (!inquiry?.status) {
            if (
                inquiry?.initiated?.name === inquiry?.last_message?.sender?.name
            )
                return {
                    name: "Need your reply",
                    class: `${styles.statusTxt} ${styles.noNeed}`,
                };
            return {
                name: "Pending",
                class: `${styles.statusTxt} ${styles.pending}`,
            };
        }
        return {
            name: "Resolved",
            class: `${styles.statusTxt} ${styles.btngrnResolve}`,
        };
    };
    const {
        data: messagesForInquiry,
        isError: messagesForInquiryisError,
        isLoading: messagesForInquiryisLoading,
        isSuccess: messagesForInquiryisSuccess,
        refetch: messagesForInquiryrefetch,
    } = useFetch(
        ["inquiry-meassages", messageData?.data?.data?.id],
        `inquiry/${messageData?.data?.data?.id}/messages
        `
    );
    useEffect(() => {
        setMessage(messageData?.data?.data);
        setMessageStatus(getStatus(messageData?.data?.data));
    }, [messageData]);
    return (
        <ManagerDashboardWapper>
            <ApiLoader loading={messageDataisLoading && !message} />
            {messageDataisLoading && !message ? (
                ""
            ) : (
                <Box className={styles.messagedetails}>
                    {/* <Box className={styles.messagedetails_btms}> */}
                    {/* <PerfectScrollbar className={styles.scrolls_container}> */}
                    <Box className={styles.message_details_outers}>
                        <Box className={styles.message_details_outers_lf}>
                            <PerfectScrollbar
                                className={styles.detailsColLeft_scroll}
                            >
                                <Box className={styles.messagedetails_top}>
                                    <Typography
                                        variant="h4"
                                        className={styles.cmn_h4}
                                    >
                                        {message?.video
                                            ? "Message Details"
                                            : "Ticket Details"}
                                    </Typography>
                                    <Button
                                        className={styles.back_btn_sec}
                                        onClick={goBack}
                                    >
                                        <i>
                                            <BackArrow />
                                        </i>{" "}
                                        Back
                                    </Button>
                                </Box>
                                {message?.video ? (
                                    <Box
                                        className={styles.jumped_umbrella_outer}
                                    >
                                        <Box className={styles.figure_main}>
                                            <img
                                                src={getAbsoluteImageURI(
                                                    message?.video?.thumbnail
                                                )}
                                                alt=""
                                            />
                                        </Box>
                                        <Box
                                            className={
                                                styles.jumped_umbrella_btms
                                            }
                                        >
                                            <Box
                                                className={
                                                    styles.more_details_top
                                                }
                                            >
                                                <Typography
                                                    variant="h5"
                                                    className={styles.cmn_h5}
                                                >
                                                    <Link to="/">
                                                        {message?.video?.title
                                                            ? message?.video
                                                                  ?.title
                                                            : "N/A"}
                                                    </Link>
                                                </Typography>
                                                <Box
                                                    className={
                                                        styles.vsid_detais
                                                    }
                                                >
                                                    <Box
                                                        className={
                                                            styles.vsid_detais_lft
                                                        }
                                                    >
                                                        <Button
                                                            className={
                                                                styles.vsid_span
                                                            }
                                                        >
                                                            VSID:{" "}
                                                            <Typography variant="caption">
                                                                #
                                                                {message?.video
                                                                    ?.id
                                                                    ? message
                                                                          ?.video
                                                                          ?.id
                                                                    : "N/A"}
                                                            </Typography>
                                                        </Button>
                                                    </Box>
                                                    <Box
                                                        className={
                                                            styles.vsid_detais_rtt
                                                        }
                                                    >
                                                        <Button
                                                            className={
                                                                styles.more_details_btn
                                                            }
                                                        >
                                                            More details
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            <Box
                                                className={
                                                    styles.more_details_btms
                                                }
                                            >
                                                <Typography
                                                    variant="h5"
                                                    className={
                                                        styles.creation_date
                                                    }
                                                >
                                                    Created on:
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    className={
                                                        styles.creation_time
                                                    }
                                                >
                                                    {message?.created
                                                        ? getStyledDateTime(
                                                              message?.created
                                                          )
                                                        : "N/A"}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                ) : (
                                    <>
                                        <Paper
                                            className={`${styles.forTicketDetails}`}
                                        >
                                            <List disablePadding>
                                                <ListItem>
                                                    <Typography variant="caption">
                                                        Subject
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {message?.subject}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem>
                                                    <Typography variant="caption">
                                                        Created on
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {getStyledDateTime(
                                                            message?.created
                                                        )}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem>
                                                    <Typography variant="caption">
                                                        Last updated
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {getStyledDateTime(
                                                            message?.created
                                                        )}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem>
                                                    <Typography variant="caption">
                                                        Sender
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {
                                                            message?.initiated
                                                                ?.name
                                                        }
                                                        <span
                                                            className={
                                                                styles.txtDes
                                                            }
                                                        >
                                                            (
                                                            {
                                                                message
                                                                    ?.initiated
                                                                    ?.role
                                                                    ?.display_name
                                                            }
                                                            )
                                                        </span>
                                                    </Typography>
                                                </ListItem>
                                            </List>
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                className={styles.secPriority}
                                            >
                                                <Typography variant="overline">
                                                    Priority:
                                                </Typography>

                                                {/* =========== PRIORITY BUTTONS START ============ */}
                                                {message?.priority?.toString() ? (
                                                    message?.priority === 0 ? (
                                                        <Typography
                                                            variant="caption"
                                                            className={
                                                                styles.priorityLow
                                                            }
                                                        >
                                                            Low{" "}
                                                        </Typography>
                                                    ) : message?.priority ===
                                                      1 ? (
                                                        <Typography
                                                            variant="caption"
                                                            className={
                                                                styles.priorityMedium
                                                            }
                                                        >
                                                            Medium
                                                        </Typography>
                                                    ) : message?.priority ===
                                                      2 ? (
                                                        <Typography
                                                            variant="caption"
                                                            className={
                                                                styles.priorityHigh
                                                            }
                                                        >
                                                            High
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="caption"
                                                            className={
                                                                styles.priorityCritical
                                                            }
                                                        >
                                                            Critical
                                                        </Typography>
                                                    )
                                                ) : (
                                                    <Typography
                                                        variant="caption"
                                                        className={
                                                            styles.priorityLow
                                                        }
                                                    >
                                                        Low
                                                    </Typography>
                                                )}

                                                {/* =========== PRIORITY BUTTONS END== ============ */}
                                            </Stack>
                                        </Paper>
                                    </>
                                )}
                                <Box className={styles.file_uld_options_outr}>
                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <h5 className={styles.option_h5}>
                                            Attached Files
                                        </h5>
                                        {message?.attachments?.length ? (
                                            <Box
                                                className={
                                                    styles.file_uploader_all
                                                }
                                            >
                                                <PerfectScrollbar
                                                    className={
                                                        styles.perfectscrollinfo
                                                    }
                                                >
                                                    {message?.attachments.map(
                                                        (item, index) => (
                                                            <Button
                                                                className={
                                                                    item?.status
                                                                        ? `${styles.file_uploader_all_inner} ${styles.active}`
                                                                        : `${styles.file_uploader_all_inner}`
                                                                }
                                                                key={index}
                                                                onClick={() =>
                                                                    handleDownload(
                                                                        item?.file
                                                                    )
                                                                }
                                                            >
                                                                <i>
                                                                    <UploadIcon />
                                                                </i>
                                                                <Box
                                                                    className={
                                                                        styles.rt_contents
                                                                    }
                                                                >
                                                                    {item?.name}
                                                                </Box>
                                                            </Button>
                                                        )
                                                    )}
                                                </PerfectScrollbar>
                                            </Box>
                                        ) : (
                                            <Paper
                                                className={`${styles.styledPaper} ${styles.noAttachFile}`}
                                            >
                                                <img
                                                    src={assest.IconNofile}
                                                    alt="icon"
                                                />
                                                <Typography variant="caption">
                                                    All files that will be
                                                    uploaded will be displayed
                                                    in this section
                                                </Typography>
                                            </Paper>
                                        )}
                                    </Box>

                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <Box
                                            className={styles.initiate_msg_div}
                                        >
                                            <Typography variant="body1">
                                                <strong>
                                                    {message?.recipent?.name
                                                        ? message?.recipent
                                                              ?.name
                                                        : "N/A"}
                                                </strong>{" "}
                                                <Typography
                                                    variant="caption"
                                                    className={
                                                        styles.editor_spn
                                                    }
                                                >
                                                    (
                                                    {message?.initiated?.name
                                                        ? message?.initiated
                                                              ?.name
                                                        : "N/A"}
                                                    )
                                                </Typography>{" "}
                                                initiated this message.
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <Box
                                            className={
                                                styles.status_message_field
                                            }
                                        >
                                            <Box
                                                className={
                                                    styles.status_message_field_top
                                                }
                                            >
                                                <Typography
                                                    variant="caption"
                                                    className={
                                                        styles.status_text
                                                    }
                                                >
                                                    Status:
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    // className={`${styles.status_valuesec} ${styles.pendingstat}`}
                                                    className={
                                                        messageStatus.class
                                                    }
                                                >
                                                    {messageStatus.name}
                                                </Typography>
                                            </Box>
                                            {message?.resolved_by ? (
                                                <List
                                                    className={
                                                        styles.statusList
                                                    }
                                                >
                                                    <ListItem
                                                        sx={{
                                                            textTransform:
                                                                "capitalize",
                                                        }}
                                                    >
                                                        <span>By:</span>
                                                        {message?.resolved_by
                                                            ?.name ||
                                                        message?.resolved_by
                                                            ?.last_name
                                                            ? `${message?.resolved_by?.name} ${message?.resolved_by?.last_name}`
                                                            : "N/A"}
                                                    </ListItem>
                                                    <ListItem>
                                                        <span>On:</span>
                                                        {getStyledDateTime(
                                                            message?.resolved_at
                                                        )
                                                            ? getStyledDateTime(
                                                                  message?.resolved_at
                                                              )
                                                            : "N/A"}
                                                    </ListItem>
                                                </List>
                                            ) : (
                                                ""
                                            )}

                                            <Box
                                                className={
                                                    styles.status_message_field_btm
                                                }
                                            >
                                                {messageStatus.name ? (
                                                    messageStatus.name ===
                                                        "Need your reply" ||
                                                    messageStatus.name ===
                                                        "Pending" ? (
                                                        <List>
                                                            <ListItem>
                                                                <Button
                                                                    className={
                                                                        styles.black_btns
                                                                    }
                                                                    onClick={
                                                                        handleRespondToInquiry
                                                                    }
                                                                >
                                                                    Respond
                                                                </Button>
                                                            </ListItem>

                                                            <ListItem>
                                                                <Button
                                                                    className={
                                                                        styles.gryy_btns
                                                                    }
                                                                    onClick={
                                                                        resolveInquiry
                                                                    }
                                                                >
                                                                    Mark as
                                                                    resolved
                                                                </Button>
                                                            </ListItem>
                                                        </List>
                                                    ) : (
                                                        <List>
                                                            <ListItem>
                                                                <Button
                                                                    className={
                                                                        styles.black_btns
                                                                    }
                                                                    onClick={
                                                                        openInquiry
                                                                    }
                                                                >
                                                                    Open Again
                                                                </Button>
                                                            </ListItem>

                                                            <ListItem>
                                                                <Button
                                                                    className={
                                                                        styles.gryy_btns
                                                                    }
                                                                    onClick={
                                                                        archiveInquiry
                                                                    }
                                                                >
                                                                    Archive
                                                                </Button>
                                                            </ListItem>
                                                        </List>
                                                    )
                                                ) : (
                                                    ""
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </PerfectScrollbar>
                        </Box>
                        <PerfectScrollbar
                            className={styles.detailsColRight_scroll}
                        >
                            <Box className={styles.message_details_outers_rt}>
                                <Box className={styles.message_fileout_div}>
                                    {!respondToInquiry ? (
                                        <Box
                                            className={styles.respond_div_marks}
                                        >
                                            <Box
                                                className={
                                                    styles.respond_div_marks_outer
                                                }
                                            >
                                                <List>
                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.respond_btnss
                                                            }
                                                            onClick={
                                                                handleRespondToInquiry
                                                            }
                                                        >
                                                            Respond
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.respond_unread_btn
                                                            }
                                                            onClick={
                                                                resolveInquiry
                                                            }
                                                        >
                                                            Mark as{" "}
                                                            <strong>
                                                                resolved
                                                            </strong>
                                                        </Button>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <MessageTypeBox
                                            inquiry={message}
                                            toggleRepondToInquiry={
                                                handleRespondToInquiry
                                            }
                                            refreshMessages={
                                                messagesForInquiryrefetch
                                            }
                                        />
                                    )}

                                    <Box
                                        className={
                                            styles.agent_share_fileattchd
                                        }
                                    >
                                        <Box
                                            className={
                                                styles.agent_share_fileattchd_outer
                                            }
                                        >
                                            {messagesForInquiry?.data?.data.map(
                                                (item, index) => (
                                                    <Box
                                                        className={
                                                            styles.agent_share_inners
                                                        }
                                                        key={index}
                                                    >
                                                        <Box
                                                            className={
                                                                styles.agent_share_inners_top
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.share_agents_lft
                                                                }
                                                            >
                                                                <Box
                                                                    className={
                                                                        styles.agent_info_fgr_Wrap
                                                                    }
                                                                >
                                                                    <Box
                                                                        className={
                                                                            styles.agent_info_fgr_Wrap_img
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                item
                                                                                    ?.sender
                                                                                    ?.image
                                                                                    ? concatHostAndImagePath(
                                                                                          item
                                                                                              ?.sender
                                                                                              ?.image
                                                                                      )
                                                                                    : assest.messageProfileIcon
                                                                            }
                                                                            alt=""
                                                                        />
                                                                    </Box>

                                                                    <Box
                                                                        className={
                                                                            styles.agent_info_fgr_Wrap_content
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant="h5"
                                                                            className={
                                                                                styles.cmn_h5
                                                                            }
                                                                        >
                                                                            {
                                                                                item
                                                                                    ?.sender
                                                                                    ?.name
                                                                            }
                                                                        </Typography>
                                                                        {item?.desgnation && (
                                                                            <Typography
                                                                                variant="caption"
                                                                                className={
                                                                                    styles.desg_inner
                                                                                }
                                                                            >
                                                                                (
                                                                                {
                                                                                    item
                                                                                        ?.sender
                                                                                        ?.role
                                                                                        ?.display_name
                                                                                }
                                                                                )
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                </Box>
                                                            </Box>

                                                            <Box
                                                                className={
                                                                    styles.share_agents_rtt
                                                                }
                                                            >
                                                                <Typography
                                                                    variant="caption"
                                                                    className={
                                                                        styles.agent_date
                                                                    }
                                                                >
                                                                    {getStyledDateTime(
                                                                        item?.created
                                                                    )}{" "}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box
                                                            className={
                                                                styles.agent_share_inners_btm
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.description_box
                                                                }
                                                            >
                                                                <Typography variant="body1">
                                                                    {
                                                                        item?.message
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            {item?.attachments
                                                                ?.length ? (
                                                                <Box
                                                                    className={
                                                                        styles.description_attached_boxes
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="h5"
                                                                        className={
                                                                            styles.cmn_h5
                                                                        }
                                                                    >
                                                                        Attached
                                                                        files:
                                                                    </Typography>
                                                                    {item?.attachments.map(
                                                                        (
                                                                            file,
                                                                            index
                                                                        ) => (
                                                                            <Button
                                                                                key={
                                                                                    index
                                                                                }
                                                                                className={
                                                                                    styles.button_pdf_styled
                                                                                }
                                                                                onClick={() =>
                                                                                    handleDownload(
                                                                                        file?.file
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i>
                                                                                    <DownArrowBlue />
                                                                                </i>
                                                                                {
                                                                                    file?.name
                                                                                }
                                                                            </Button>
                                                                        )
                                                                    )}
                                                                </Box>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Box>
                                                    </Box>
                                                )
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </PerfectScrollbar>
                    </Box>
                    {/* </PerfectScrollbar> */}
                    {/* </Box> */}
                </Box>
            )}
        </ManagerDashboardWapper>
    );
}
